import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'py-cart-empty-notification',
  templateUrl: './cart-empty-notification.component.html',
  styleUrls: ['./cart-empty-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CartEmptyNotificationComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
